import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface TotalDistanceIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function TotalDistanceIcon({
  color = RoutalPalette.secondary60,
  style = {},
  ...props
}: TotalDistanceIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 13 12" style={{ height: `14px`, width: `14px`, ...style }}>
      <g>
        <path
          d="M11.0391 9.23077C10.4051 9.23077 9.86946 9.61754 9.66786 10.1538H3.42174C2.34751 10.1538 1.47391 9.32585 1.47391 8.30769C1.47391 7.28954 2.34751 6.46154 3.42174 6.46154H9.57826C11.1891 6.46154 12.5 5.21908 12.5 3.69231C12.5 2.16554 11.1891 0.923077 9.57826 0.923077H3.33214C3.13054 0.386769 2.59489 0 1.96087 0C1.15544 0 0.5 0.621231 0.5 1.38462C0.5 2.148 1.15544 2.76923 1.96087 2.76923C2.59489 2.76923 3.13054 2.38246 3.33214 1.84615H9.57826C10.6525 1.84615 11.5261 2.67415 11.5261 3.69231C11.5261 4.71046 10.6525 5.53846 9.57826 5.53846H3.42174C1.81089 5.53846 0.5 6.78092 0.5 8.30769C0.5 9.83446 1.81089 11.0769 3.42174 11.0769H9.66786C9.86946 11.6132 10.4051 12 11.0391 12C11.8446 12 12.5 11.3788 12.5 10.6154C12.5 9.852 11.8446 9.23077 11.0391 9.23077ZM1.96087 1.84615C1.83172 1.84615 1.70786 1.79753 1.61654 1.71097C1.52522 1.62442 1.47391 1.50702 1.47391 1.38462C1.47391 1.26221 1.52522 1.14481 1.61654 1.05826C1.70786 0.971703 1.83172 0.923077 1.96087 0.923077C2.09002 0.923077 2.21388 0.971703 2.3052 1.05826C2.39652 1.14481 2.44783 1.26221 2.44783 1.38462C2.44783 1.50702 2.39652 1.62442 2.3052 1.71097C2.21388 1.79753 2.09002 1.84615 1.96087 1.84615ZM11.0391 11.0769C10.91 11.0769 10.7861 11.0283 10.6948 10.9417C10.6035 10.8552 10.5522 10.7378 10.5522 10.6154C10.5522 10.493 10.6035 10.3756 10.6948 10.289C10.7861 10.2025 10.91 10.1538 11.0391 10.1538C11.1683 10.1538 11.2921 10.2025 11.3835 10.289C11.4748 10.3756 11.5261 10.493 11.5261 10.6154C11.5261 10.7378 11.4748 10.8552 11.3835 10.9417C11.2921 11.0283 11.1683 11.0769 11.0391 11.0769Z"
          fill={color}
        />
        <circle cx="1.97028" cy="1.35373" r="0.670715" fill={color} />
        <circle cx="11.0728" cy="10.6479" r="0.670715" fill={color} />
      </g>
    </SvgIcon>
  );
}
